//#region import libraries
import React, { useState } from 'react';
//bootstrap
import { Button, Form, Container } from 'react-bootstrap';
//tremor
import { Flex } from "@tremor/react"
//styles
import { Colors } from '_styles';
//#endregion

const HoursRangeSelector = (props) => {
  //#region local state

  const [hours, setHours] = useState({
    openHour: "",
    closeHour: "",
  });
  const [twentyFourAvailable, setTwentyFourAvailable] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const [errors, setErrors] = useState("");
  //#endregion

  //#region functions
  //this function to convert selected time to minutes
  const convertToMinutes = (time) => {
    const [hours, minutes] = time.split(':');
    return parseInt(hours) * 60 + parseInt(minutes);
  };

  const validateTimes = () => {
    const { openHour, closeHour } = hours
    if (!openHour.length && !closeHour.length) return
    const startMinutes = convertToMinutes(openHour);
    const endMinutes = convertToMinutes(closeHour);
    // If the start time is not less than the end time, show an error
    if (startMinutes <= endMinutes) {   // I reverse the condition since when I select AM time it treats as PM
      setErrors('Open hour should be earlier than the close hour');
      setEnableSave(false)
    } else {
      setErrors("")
    }
  }

  const handleChangeHour = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setHours((prevState) => {
      const updatedFields = { ...prevState, [name]: value };
      // validateTimes()    
      if (updatedFields.openHour.length && updatedFields.closeHour.length) {
        setEnableSave(true)
      }
      return updatedFields;
    });
  }
  const handleChecking = (event) => {

    if (event.target.checked) {
      setTwentyFourAvailable(true)
      setHours({
        openHour: "00:00",
        closeHour: "23:59",
      })
      setEnableSave(true)
    } else {
      setTwentyFourAvailable(false)
      setEnableSave(false)
      setHours({
        openHour: "",
        closeHour: "",
      })
    }
  }

  return (
    <Container>
      <h4 className='mt-2' style={{ color: Colors.PRM_LIGHT_BLUE }}>Select Hours Range</h4>
      <hr style={{ color: Colors.PRM_LIGHT_BLUE }} />

      <Container>
        <Form>
          {/*check 24/7 availability option*/}
          <Form.Group className="mb-3">
            <Flex >
              <Form.Label>Available 24/7</Form.Label>
              <Form.Check
                type="switch"
                name='twentyFour'
                value={twentyFourAvailable}
                defaultChecked={false}
                onChange={handleChecking}
              />

            </Flex>
          </Form.Group>

          {/*select open  hours*/}
          <Form.Group className="mb-3">
            <Form.Label>Opening hour</Form.Label>
            <Form.Control
              type="time"
              value={hours.openHour}
              name='openHour'
              onChange={handleChangeHour}
              required
              disabled={twentyFourAvailable}
            />
          </Form.Group>

          {/*select close  hours*/}
          <Form.Group className="mb-3">
            <Form.Label>Closing hour</Form.Label>
            <Form.Control
              type="time"
              name='closeHour'
              value={hours.closeHour}
              onChange={handleChangeHour}
              required
              disabled={twentyFourAvailable}
            />
          </Form.Group>

        </Form>
        {errors && (<p className="text-danger">{errors}</p>)}

      </Container>

      <hr style={{ color: Colors.PRM_LIGHT_BLUE }} />
      {/*Buttons to close and save*/}
      <Container style={{ marginBottom: 18 }}>
        <Flex>
          <Button variant="outline-danger" onClick={props.cancel}>Close</Button>
          <Button variant="outline-primary" disabled={!enableSave} onClick={() => { props.done({ openHour: hours.openHour, closeHour: hours.closeHour }) }}> Save  </Button>
        </Flex>
      </Container>

    </Container>
  );
};

export default HoursRangeSelector;
